import getPerspectives from '../api/getPerspectives';

export default function getPerspective() {
    console.log('inicio da funçao')
    return (dispatch, state) => {
        // dispatch({type: "MODEL_GET_STARTING"});
        getPerspectives().then(perspectives => {
            console.log("perspectives", perspectives)
                dispatch({type: "GET_PERSPECTIVES", perspectives: perspectives});
        }).catch( error =>{
            console.error(error)
            // dispatch({type: "MODEL_GET_ALL_ERROR", error:error});
        })
    }
}